import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {PartRequest} from "../api";

export class PartRequestService extends RestService<PartRequest> {
    constructor(url: string) {
        if (url) {
            super(url)
        } else {
            super(REST_API_END_POINTS.PART_REQUEST)
        }
    }
}
